import React from 'react';
import { Button, Space } from '@cashfree-intl/coherent';
import { SubStepDescription } from 'containers/CheckoutJourney/screens/styled';
import {
  INTEGRATION_STATUS,
  IntegrationEvents,
} from 'containers/CheckoutJourney/util/constant';
import { sendAnalyticsData } from 'containers/ProductTour/helper';
import { SubstepComponentProps } from 'containers/CheckoutJourney/types';

const UpdateBaseApi = ({ substep, updateStatus }: SubstepComponentProps) => {
  const markAsDone = (): void => {
    updateStatus(
      IntegrationEvents.PROD_FIRST_TXN,
      INTEGRATION_STATUS.COMPLETED,
    );
    sendAnalyticsData('updateBaseAPISDKButtonClicked');
  };

  return (
    <Space gap={2.5} direction="column" className="mt-2">
      <SubStepDescription color="bodyLight">
        {substep.description}
      </SubStepDescription>
      <Space>
        <Button primary onClick={markAsDone}>
          Mark as Done
        </Button>
      </Space>
    </Space>
  );
};

export { UpdateBaseApi };
